// Display constants for the Mentorship screens. Mentors, availability and
// bookings come from the API (see api/mentorshipService.js); the real price and
// payout split are enforced server-side, these are just for display.

export const SESSION_PRICE = 149;
export const SESSION_MINUTES = 30;

export const MENTOR_CATEGORIES = [
  "All",
  "Per Diem / PRN",
  "Money & Investing",
  "Travel Nursing",
  "New Grad",
  "Real Estate",
  "Advanced Practice",
  "Leadership",
  "Content & Side Income",
];
